import React from 'react'
import { notificationActions } from "../actions";
import { useSelector, useDispatch } from 'react-redux'
import { Snackbar, IconButton } from '@mui/material';
import { Alert } from '@mui/material';
import { Close } from '@mui/icons-material';

const Notifications = () => {
  const dispatch = useDispatch();
  const show = useSelector(state => state.notification.show);
  const message = useSelector(state => state.notification.message);
  const severity = useSelector(state => state.notification.severity);
  const autoHideDuration = useSelector(state => state.notification.autoHideDuration);

  const onClose = () => {
    dispatch(notificationActions.hide());
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={autoHideDuration}
      open={show}
      onClose={onClose}
      style={{ top: '75px' }}
    >
      <Alert variant="filled" severity={severity}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={onClose}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notifications;